export default __webpack_public_path__ + "static/9-7da9b1e862bcf9695fba6f2d5d111eb2.png";